import React from "react";
import DashboardMyBooksPage from "../Books/DashboardMyBooks";
import DashboardMybooklist from "../Books/DashboardMybooklist";
import {connect} from "react-redux";
import UserWelcomeComponentDashboard from "../Books/UserWelcomeComponentDashboard";

class Dashboard extends React.Component{


    render(){
        return(
            <div>
                {this.props.books ? ( this.props.bookLists ? (this.props.books.length !== 0 &&
                    <div>
                <h1 className="content_title">Showing From Mostly Recently Viewed</h1>
                {console.log(this.props.books)}
                <DashboardMyBooksPage /><br/>
                <div className="recentBooklists">
                <h1 className="book_title">Recent Booklists</h1>
                <DashboardMybooklist/>
                </div><br/></div>
                ):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                )
                :<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
            }
            {this.props.books && this.props.books.length === 0 &&
                <UserWelcomeComponentDashboard />
            }
            </div>
        );
    };
};

function mapStateToProps(state){
    return {books: state.AllBooks.books, bookLists: state.AllBooklists.bookLists}
}

export default connect(mapStateToProps, {}) (Dashboard);